module.exports = __webpack_public_path__ + "img/flomakt.52db7499.jpg";